import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import { setUser } from './userSlice';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAuthStatus, setToken } from '../../request/Auth/authSlice';
import { useQuery } from 'react-query';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Currency } from '@depay/local-currency';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import { Container, IconButton, InputAdornment } from '@mui/material';
import { 
  Visibility, 
  VisibilityOff, 
  Email, 
  Lock, 
  Person, 
  Phone, 
  LocationOn, 
  ArrowForward,
  Public
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Styled components for better visual hierarchy
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  boxShadow: theme.palette.mode === 'dark' 
    ? '0 8px 32px rgba(0, 0, 0, 0.4)' 
    : '0 8px 32px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(10px)',
  border: theme.palette.mode === 'dark' 
    ? '1px solid rgba(255, 255, 255, 0.1)' 
    : '1px solid rgba(255, 255, 255, 0.8)',
  background: theme.palette.mode === 'dark' 
    ? 'linear-gradient(135deg, rgba(30, 30, 30, 0.9), rgba(20, 20, 20, 0.9))' 
    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.9))',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '12px 24px',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  background: 'linear-gradient(135deg, #0050b4 0%, #0070fc 100%)',
  boxShadow: '0 4px 15px rgba(0, 80, 180, 0.4)',
  '&:hover': {
    background: 'linear-gradient(135deg, #003d8c 0%, #0050b4 100%)',
    boxShadow: '0 6px 20px rgba(0, 80, 180, 0.6)',
  },
}));

const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: '12px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
    borderWidth: '2px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#0050b4',
    borderWidth: '2px',
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: '12px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
    borderWidth: '2px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#0050b4',
    borderWidth: '2px',
  },
}));

const Register = () => {
    const [countries, setCountries] = useState('');
    const { isLoading: isloadingCountries, refetch: getCountries } = useQuery(
        "countries",
        async () => {
          return await apiClient.get("/api/countries");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setCountries(res.data.countries);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

    const dispatch = useDispatch();
    const initialLogin = {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone: '',
        address: '',
        referral: '',
        country: ''

    }
   
    const [error, setErros] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    
    const [registerForm, setRegisterForm] = useState(initialLogin);
    const appMode = useSelector((state) => state.mode.mode);
    const redirectTo = useSelector((state) => state.redirect.redirect);
    const inviter = useSelector((state) => state.referrals.inviter);

    const navigate = useNavigate();

    const onChange = (e) =>
    setRegisterForm({ ...registerForm, [e.target.name]: e.target.value });
    let currency = Currency.getCode();

    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(
        
        async () => {
          return await apiClient.post(`/api/register`, {
            name: registerForm.name,
            email: registerForm.email,
            password: registerForm.password,
            password_confirmation: registerForm.password_confirmation,
            phone: registerForm.phone,
            address: registerForm.address,
            referral: inviter,
            country: registerForm.country,
            currency: currency
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('auth-token', res.data.access_token);
            dispatch(setUser(res.data.user));
            dispatch(setAuthStatus('authenticated'));
            dispatch(setToken(res.data.access_token));
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);

            if (redirectTo !== '') {
                navigate(redirectTo);
            }else{
                window.location.href  = '/';
              }

          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.errors)  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);     
          },
        }
      );
      const onSubmit = async() =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postLogin();
      } 

      useEffect(() => {
        getCountries();
      }, []);

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        background: appMode === 'dark' 
          ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)'
          : 'linear-gradient(135deg, #0050b4 0%, #0070fc 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: '10px', sm: '15px', md: '20px' }
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        <StyledCard sx={{ maxWidth: '1000px', mx: 'auto' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
            {/* Logo Section */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <img  
                src={appMode === 'dark'? '/logos/youngtrade-logo-white.png' : '/logos/youngtrade-logo-dark.png'} 
                style={{height: '80px', marginBottom: '16px'}} 
                alt="Young Trade Logo" 
              />
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 700, 
                  background: 'linear-gradient(135deg, #0050b4 0%, #0070fc 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1
                }}
              >
                Create Account
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '16px'
                }}
              >
                Join us and start your trading journey today
              </Typography>
            </Box>

            {/* Referral Alert */}
            {(inviter !== '' && inviter !== null) && (
              <Alert 
                severity="info" 
                sx={{ 
                  mb: 3, 
                  borderRadius: '12px',
                  '& .MuiAlert-icon': { fontSize: '20px' }
                }}
              >
                Your referral code is <strong>{inviter}</strong>
              </Alert>
            )}

            {/* Form Fields */}
            <Grid container spacing={3}>
              {/* Name Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="name"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Full Name
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.name}
                    onChange={onChange}
                    id="name"
                    name="name"
                    type="text"
                    label="Full Name"
                    startAdornment={
                      <InputAdornment position="start">
                        <Person sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.name && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.name}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Email Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="email"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Email Address
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.email}
                    onChange={onChange}
                    id="email"
                    type="email"
                    name="email"
                    label="Email Address"
                    startAdornment={
                      <InputAdornment position="start">
                        <Email sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.email && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.email}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Phone Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="phone"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Phone Number
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.phone}
                    onChange={onChange}
                    id="phone"
                    name="phone"
                    type="tel"
                    label="Phone Number"
                    startAdornment={
                      <InputAdornment position="start">
                        <Phone sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.phone && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.phone}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Country Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="country"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Country
                  </InputLabel>
                  <StyledSelect
                    value={registerForm.country}
                    onChange={onChange}
                    name="country"
                    label="Country"
                    startAdornment={
                      <InputAdornment position="start">
                        <Public sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  >
                    {countries && countries.map((country) => (
                      <MenuItem key={country.id} value={country.id}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                  {error !== '' && error.country && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.country}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Address Field */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="address"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Address
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.address}
                    onChange={onChange}
                    id="address"
                    name="address"
                    type="text"
                    label="Address"
                    startAdornment={
                      <InputAdornment position="start">
                        <LocationOn sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.address && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.address}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Password Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="password"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Password
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.password}
                    onChange={onChange}
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          sx={{ color: 'text.secondary' }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.password && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.password}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Confirm Password Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="password_confirmation"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#0050b4' }
                    }}
                  >
                    Confirm Password
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.password_confirmation}
                    onChange={onChange}
                    id="password_confirmation"
                    name="password_confirmation"
                    type={showConfirmPassword ? 'text' : 'password'}
                    label="Confirm Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                          sx={{ color: 'text.secondary' }}
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.password_confirmation && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.password_confirmation}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>

            {/* Action Links */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              mt: 4,
              mb: 3
            }}>
              <Typography variant="body2" sx={{ color: 'text.secondary', mr: 1 }}>
                Already have an account?
              </Typography>
                              <Link 
                  component={RouterLink} 
                  to='/login' 
                  underline="none"
                  sx={{ 
                    color: '#0050b4',
                    fontWeight: 500,
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                Sign In
              </Link>
            </Box>

            {/* Submit Button */}
            <StyledButton
              onClick={onSubmit}
              fullWidth
              size="large"
              variant="contained"
              disabled={isSendingRequest}
              endIcon={isSendingRequest ? null : <ArrowForward />}
              sx={{ 
                height: '56px',
                fontSize: '16px',
                fontWeight: 600
              }}
            >
              {isSendingRequest ? 'Creating Account...' : 'Create Account'}
            </StyledButton>

            {/* Footer */}
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '14px'
                }}
              >
                By creating an account, you agree to our Terms of Service and Privacy Policy
              </Typography>
            </Box>
          </CardContent>
        </StyledCard>
      </Container>
    </Box>
  )
}

export default Register
